import {FormField, FormFieldType, SelectionOption} from 'lionheartland';
import {ENBlockType} from '../../enums';

export class PutBlockFormFields {

    public name: FormField
    public description: FormField
    public active: FormField
    public type: FormField
    public parent: FormField
    public project: FormField

    constructor() {

        this.name = new FormField(
          'name',
          'Name',
          null,
          FormFieldType.text,
          false,
        )
        this.description = new FormField(
          'description',
          'Description',
          null,
          FormFieldType.text,
          false,
          true,
          ""
        )
        this.active = new FormField(
          'active',
          'Active',
          null,
          FormFieldType.boolean,
          false,
        )
        this.type = new FormField(
          'type',
          'Type',
          null,
          FormFieldType.enumeration,
          false,
        )
        this.type.enumeration = ENBlockType
        this.parent = new FormField(
          'parent',
          'Parent',
          'block',
          FormFieldType.pushedSelectionList,
          false,
        )
        this.project = new FormField(
          'project',
          'Project',
          'project',
          FormFieldType.pushedSelectionList,
          false,
        )

    }
}

const fields = new PutBlockFormFields()

export const putBlockFormFieldOptions: {[key: string]: FormField} = {
  name: fields.name,
  description: fields.description,
  active: fields.active,
  type: fields.type,
  parent: fields.parent,
  project: fields.project,
};